import { supabase } from "../../Services/supabaseClient";

export const getCrmSettings = async (companyId) => {
  const { data, error } = await supabase
    .from("crm_settings")
    .select("*")
    .eq("company_id", companyId)
    .maybeSingle();

  if (error) {
    throw error;
  }

  if (data) {
    return data;
  }

  const { data: inserted, error: insertError } = await supabase
    .from("crm_settings")
    .insert([
      {
        company_id: companyId,
      },
    ])
    .select()
    .single();

  if (insertError) {
    throw insertError;
  }

  return inserted;
};

export const updateCrmSettings = async (companyId, payload) => {
  const { data, error } = await supabase
    .from("crm_settings")
    .update(payload)
    .eq("company_id", companyId)
    .select()
    .single();

  if (error) {
    throw error;
  }

  return data;
};
